import(/* webpackMode: "eager" */ "/app/src/app/chat/error.tsx");
